import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import {currentOverlaySwitch} from '../../config/currentOverlaySwitch';
import StandardOverlay from '../../components/blueprintWrappers/StandardOverlay';

/**
 * Renders: StandardOverlay and {@link currentOverlaySwitch}
 * @props {Object} currentOverlay - redux -> globalState.currentOverlay
 * @returns StandardOverlay
 */
class CurrentOverlayContainer extends Component {
	render() {
		return this.currentOverlay();
	}

	currentOverlay = () => {
		const { currentOverlay } = this.props;
		return currentOverlay === null ? null : <StandardOverlay 
			isOpen = {true}
		>
			{currentOverlaySwitch(currentOverlay)}
		</StandardOverlay>
	}
}
function mapStateToProps(state) {
	return {
		currentOverlay: state.globalState.currentOverlay
	}
}

const mapDispatchToProps = dispatch => {
	return {
		
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrentOverlayContainer);


// WEBPACK FOOTER //
// ./src/containers/shared/CurrentOverlayContainer.jsx